import { Link } from 'react-router';

/**
 * Procesní lišta víceprací — Nálezy, Změny a Rekapitulace jsou TŘI FÁZE
 * jednoho procesu (hlídač víceprací), ne samostatné agendy. Lišta je na
 * všech třech stránkách: ukazuje, kde v procesu jsem, a přepíná fáze.
 */
const KROKY = [
  { krok: 1 as const, cesta: '/nalezy', nazev: 'Nálezy', popis: 'rozhodnout, co je vícepráce' },
  { krok: 2 as const, cesta: '/zmeny', nazev: 'Změny', popis: 'ocenit obě strany a schválit' },
  {
    krok: 3 as const,
    cesta: '/rekapitulace',
    nazev: 'Rekapitulace',
    popis: 'peníze, marže a rizika',
  },
];

export function ProcesViceprace({ krok }: { krok: 1 | 2 | 3 }) {
  return (
    <nav
      aria-label="Proces víceprací"
      className="flex flex-wrap items-center gap-1 text-xs font-semibold"
    >
      <span className="mr-1 tracking-wider text-text-muted uppercase">Vícepráce</span>
      {KROKY.map((k, i) => (
        <span key={k.cesta} className="flex items-center gap-1">
          {i > 0 && (
            <span aria-hidden="true" className="text-text-muted">
              ›
            </span>
          )}
          <Link
            to={k.cesta}
            title={k.popis}
            aria-current={k.krok === krok ? 'step' : undefined}
            className={`inline-flex items-center gap-1.5 rounded-full py-1 pr-2.5 pl-1 transition-colors duration-100 ${
              k.krok === krok
                ? 'bg-primary text-white'
                : 'text-text-secondary hover:bg-primary-tint hover:text-primary'
            }`}
          >
            <span
              aria-hidden="true"
              className={`flex size-4.5 items-center justify-center rounded-full text-[10px] font-bold ${
                k.krok === krok ? 'bg-accent text-text-heading' : 'bg-fill-disabled'
              }`}
            >
              {k.krok}
            </span>
            {k.nazev}
          </Link>
        </span>
      ))}
      {/* Pokračování cesty peněz — informativní, ne navigace: dodatek se
          sestavuje ze smlouvy nebo ze ZL, fakturace následuje po jeho podpisu. */}
      <span
        className="flex items-center gap-1 text-text-muted"
        title="Podepsané výnosové ZL se zařadí do dodatku (ze smlouvy nebo z detailu Změny); podpisem dodatku se Změny stanou fakturovatelné."
      >
        <span aria-hidden="true">›</span> dodatek <span aria-hidden="true">›</span> fakturace
      </span>
    </nav>
  );
}
